import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_COMMUNICATION, UPDATE_COMMUNICATION } from './constants';
import {
  loadCommunicationSuccess,
  loadCommunicationError,
  updateCommunicationSuccess,
  updateCommunicationError,
} from './actions';

import requestWrapper from 'utils/requestWrapper';

// utils
import { endpoint } from 'utils/apis/axiosAPI';

export function* loadCommunicationSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { detailID } = action;
    const newKey = 'nouvel';
    let itemDetailSaga = false;
    // we get the campaigns linked to the communication
    if (!!detailID && detailID != newKey) {
      // we get the campaigns linked to the communication
      itemDetailSaga = yield requestWrapper(
        'GET',
        endpoint?.teacher?.communications?.single(detailID),
        // `communications/${detailID}`,
        '',
        currentUser.token,
      );
    }

    if (!detailID && !itemDetailSaga) {
      yield put(loadCommunicationSuccess(false));
    } else {
      yield put(loadCommunicationSuccess(itemDetailSaga));
    }
  } catch (error) {
    yield put(loadCommunicationError(error));
  }
}


export function* updateCommunicationSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );

    const userID = currentUser?._id;

    const { itemDetail } = action;
    const ID = itemDetail?._ID;

    const newKey = 'nouvel';
    let updatedElemnet = false;
    if (!!ID && ID != newKey) {
      updatedElemnet = yield requestWrapper(
        'PATCH',
        endpoint?.teacher?.communications?.update(ID),
        itemDetail,
        currentUser.token,
      );
    }

    if (!updatedElemnet) {
      yield put(updateCommunicationSuccess(false));
    } else {
      yield put(updateCommunicationSuccess(updatedElemnet));
    }
  } catch (err) {
    yield put(updateCommunicationError(true));
  }
}

// Individual exports for testing
export default function* communicationDetailMobileSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_COMMUNICATION, loadCommunicationSaga);
  yield takeLatest(UPDATE_COMMUNICATION, updateCommunicationSaga);
}
